const slugs = {
    newsletter: "newsletter",
    sharkAlerts: "shark-alerts",
    sharkSchool: "shark-school",
    stockOfTheWeek: "stock-of-the-week",
    strategyJournal: "strategy-journal",
    weekendPost: "weekend-post"
};

const categories = [
    {
        id: 0,
        name: "Active Trader",
        archiveUrl: "/members/messageboard/activetrader.aspx",
        route: { name: "Home" },
        slug: ""
    },
    {
        id: 1,
        name: "Newsletter",
        archiveUrl: "/members/newsletters.aspx?p=archive",
        route: { name: "SearchByCategory", params: { category: slugs.newsletter } },
        slug: slugs.newsletter
    },
    {
        id: 2,
        name: "Shark Alerts",
        archiveUrl: "",
        route: { name: "SearchByCategory", params: { category: slugs.sharkAlerts } },
        slug: slugs.sharkAlerts
    },
    {
        id: 3,
        name: "Stock of the Week",
        archiveUrl: "/stock-of-the-week.aspx",
        route: { name: "SearchByCategory", params: { category: slugs.stockOfTheWeek } },
        slug: slugs.stockOfTheWeek
    },
    {
        id: 4,
        name: "Strategy Journal",
        archiveUrl: "/members/journal/default.aspx?p=archive",
        route: { name: "SearchByCategory", params: { category: slugs.strategyJournal } },
        slug: slugs.strategyJournal
    },
    {
        id: 5,
        name: "Weekend Post",
        archiveUrl: "",
        route: { name: "SearchByCategory", params: { category: slugs.weekendPost } },
        slug: slugs.weekendPost
    },
    {
        id: 6,
        name: "Shark School",
        archiveUrl: "",
        route: { name: "SearchByCategory", params: { category: slugs.sharkSchool } },
        slug: slugs.sharkSchool
    }
];

const byName = (a, b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0;

const categoryArchiveLinks = () => {
    return categories
        .filter(c => c.archiveUrl.length)
        .sort(byName);
};

const categoryLinks = () => {
    return categories
        .slice()
        .sort(byName);
};

const categoryOptions = () => {
    return categories
        .slice()
        .sort(byName)
        .map(c => {
            return {
                text: c.id ? c.name : "None",
                value: c.id.toString()
            };
        });
};

const getById = (id) => {
    return categories.find(c => c.id === id);
};

const getBySlug = (slug) => {
    if (!slug) return null;
    return categories.find(c => c.slug.toLowerCase() === slug.toLowerCase());
};

export default {
    categories,
    categoryArchiveLinks,
    categoryLinks,
    categoryOptions,
    getById,
    getBySlug
}
